/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2020, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { AnyAction } from '@reduxjs/toolkit';

import { revertVersion } from '@ibm-watson/shared/modules/ia/store/publish/actions';
import { SET_SKILL_ID } from '@ibm-watson/shared/modules/ia/store/session/actionTypes';
import { VariablesSlice } from '../../../../ts/state';
import { RESET_ACTIONS_STATE } from '../actions/actionTypes';
import * as actionTypes from './actionTypes';

const initialState: VariablesSlice = {
  skillId: null,
  listFetched: null,
  loadingVariables: false,
  deletingVariable: false
};

export const reducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case actionTypes.LIST_VARIABLES_START:
    case actionTypes.LIST_SYSTEM_VARIABLES_START:
    case actionTypes.UPDATE_VARIABLE_START:
    case actionTypes.CREATE_VARIABLE_START:
      return {
        ...state,
        loadingVariables: true
      };
    case actionTypes.DELETE_VARIABLE_START:
      return {
        ...state,
        deletingVariable: true,
        loadingVariables: true
      };
    case actionTypes.DELETE_VARIABLE_ERROR:
    case actionTypes.CREATE_VARIABLE_ERROR:
    case actionTypes.UPDATE_VARIABLE_ERROR:
      return {
        ...state,
        loadingVariables: false
      };
    case actionTypes.LIST_VARIABLES_ERROR:
    case actionTypes.LIST_SYSTEM_VARIABLES_ERROR:
      return {
        ...state,
        loadingVariables: false
      };
    case actionTypes.UPDATE_VARIABLE_SUCCESS:
    case actionTypes.CREATE_VARIABLE_SUCCESS:
    case actionTypes.LIST_SYSTEM_VARIABLES_SUCCESS:
      return {
        ...state,
        loadingVariables: false
      };
    case actionTypes.DELETE_VARIABLE_SUCCESS:
      return {
        ...state,
        deletingVariable: false,
        loadingVariables: false
      };
    case actionTypes.LIST_VARIABLES_SUCCESS:
      return {
        ...state,
        loadingVariables: false,
        listFetched: Date.now(),
        skillId: action.skillId
      };
    // Clear cache when a new skill id is set
    case SET_SKILL_ID:
    case RESET_ACTIONS_STATE:
    case revertVersion.fulfilled:
      return { ...initialState };
    default:
      return state;
  }
};
